import path from 'node:path';
import got from 'got';

import { getPkgJson } from './codebase';
import { getUnknowErrorMsg } from './tools';

import { exports as resolveExports } from 'resolve.exports';

// TODO 走 type-fest 的 PackageJson
export interface NpmPackageJson {
  name: string;
  version: string;
  description: string;
  keywords: string[];
  homepage: string;
  bugs: {
    url: string;
    email: string;
  };
  license: string;
  author: {
    name: string;
    email: string;
  };
  contributors: {
    name: string;
    email: string;
  }[];
  files: string[];
  main: string;
  browser: string;
  module: string;
  exports: Record<string, string>;
  bin: string | Record<string, string>;
  man: string | string[];
  repository: {
    type: string;
    url: string;
  };
  scripts: Record<string, string>;
  dependencies: Record<string, string>;
  devDependencies: Record<string, string>;
  peerDependencies: Record<string, string>;
  overrides: Record<string, string | Record<string, string>>;
  engines: Record<string, string>;
  os: string[];
  private: boolean;
  publishConfig: {
    registry: string;
  };
  workspaces: string[];
  dist: {
    tarball: string;
    size: number;
  };
  [key: string]: unknown;
}

export interface NpmInfo {
  'dist-tags': {
    latest: string;
    alpha: string;
    beta: string;
    rc: string;
    [key: string]: string;
  };
  name: string;
  versions: Record<string, NpmPackageJson>;
  author: {
    name: string;
    email: string;
  };
  dist: {
    tarball: string;
    size: number;
  };
  [key: string]: unknown;
}

export const registry = 'https://registry.anpm.alibaba-inc.com';

/**
 * @param name 包名称
 * @returns
 */
export const getNpmInfo = async (name: string): Promise<NpmInfo> => {
  try {
    return await got.get(`${registry}/${name}`).json<NpmInfo>();
  } catch (error) {
    return {} as NpmInfo;
  }
};

/**
 * @param name 包名称
 * @param version 版本
 * @returns
 */
export const getNpmByVersion = async (
  name: string,
  version = 'latest',
): Promise<NpmPackageJson> => {
  try {
    return await got(`${registry}/${name}/${version}`).json<NpmPackageJson>();
  } catch (error) {
    const message = getUnknowErrorMsg(error);
    throw new Error(`getNpmByVersion ${name}@version 失败，${message}`);
    // return {} as NpmPackageJson;
  }
};

export async function getLatestVersions(names: string[]): Promise<Record<string, string>> {
  const versionPromises = names.map(async (key) => {
    return getNpmByVersion(key, 'latest').then((npmInfo) => {
      return { key, version: npmInfo.version };
    });
  });

  const results = await Promise.all(versionPromises);
  const versions: Record<string, string> = {};
  results.forEach((result) => {
    versions[result.key] = result.version;
  });

  return versions;
}

/**
 * 解析本地的 npm 包入口文件路径
 *
 * @param pkgPath Package.json 所在的路径
 * @returns 绝对路径
 */
export function resovlePkgEntry(pkgPath: string) {
  const toolkitPkgJson = getPkgJson(false, pkgPath);
  let entryPoint: string | undefined;
  if (toolkitPkgJson.exports) {
    const results = resolveExports(toolkitPkgJson, '.');
    if (results && results.length) {
      [entryPoint] = results;
    }
  } else {
    entryPoint = toolkitPkgJson.module || toolkitPkgJson.main;
  }
  if (!entryPoint) {
    throw new Error(`未找到入口文件，pkgPath: ${pkgPath}`);
  }
  return path.join(pkgPath, entryPoint);
}
